import { render } from "./button.vue?vue&type=template&id=7a755c5a&scoped=true"
import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"

import "./button.vue?vue&type=style&index=0&id=7a755c5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a755c5a"]])

export default __exports__